import { Toaster } from '@/components/ui/toaster';
import AppInitializer from './components/layout/AppInitializer';
import { AuthProvider } from '@/contexts/AuthContext';
import { UserMessagesProvider } from './contexts/UserMessagesContext';
import { LocalLLMProvider } from '@/contexts/LocalLLMContext';
import type { InitialAuthState } from '@/lib/ssr-state';

type AppProps = {
  initialAuthState?: InitialAuthState;
};

function App({ initialAuthState }: AppProps) {
  return (
    <AuthProvider initialAuthState={initialAuthState}>
      <UserMessagesProvider>
        <LocalLLMProvider>
          <AppInitializer />
          <Toaster />
        </LocalLLMProvider>
      </UserMessagesProvider>
    </AuthProvider>
  );
}

export default App;
